import firebase from 'firebase'

export const CHECK_AUTH = 'CHECK_AUTH'
export const CHECK_AUTH_SUCCESS = 'CHECK_AUTH_SUCCESS'
export const CHECK_AUTH_FAIL = 'CHECK_AUTH_FAIL'

export const PERFORM_LOGOUT = 'PERFORM_LOGOUT'

export const checkAuth = () => dispatch => {
    const auth = firebase.auth()

    auth.onAuthStateChanged(user => {
        if (user) {
            dispatch(checkAuthSuccess(user.toJSON()))
        } else {
            dispatch(checkAuthFail())
        }
    })
}

export const checkAuthSuccess = (user) => {
    return ({
        type: CHECK_AUTH_SUCCESS,
        payload: user
    })
}

export const checkAuthFail = () => {
    return ({
        type: CHECK_AUTH_FAIL
    })
}

export const performLogout = () => {
    firebase.auth().signOut().then(function () {
        // Sign-out successful.
    }, function (error) {
        // An error happened.
    });
    return ({
        type: PERFORM_LOGOUT
    })
}



// WEBPACK FOOTER //
// ./src/Actions/ActionsAdmin.js